import { createFileRoute, notFound } from '@tanstack/react-router';
import { SendMoneyCalculatorPage } from '~/components/sections/SendMoneyCalculatorPage';
import { calculatorPairHeadMeta, getCalculatorPair } from '~/content/calculatorPairs';
import calculatorStylesHref from '~/styles/calculator.css?url';

export const Route = createFileRoute('/calculator/$pair')({
  loader: ({ params }) => {
    const pair = getCalculatorPair(params.pair);
    if (!pair) throw notFound();
    return { pair };
  },
  head: ({ loaderData }) => {
    const head = calculatorPairHeadMeta(loaderData?.pair);
    return {
      ...head,
      links: [...(head.links ?? []), { rel: 'stylesheet', href: calculatorStylesHref }],
    };
  },
  component: CalculatorPairPage,
});

function CalculatorPairPage() {
  const { pair } = Route.useLoaderData();
  // Remount when the slug changes so controlled calculator state resets to the
  // pair's target currency (client navigations between calculator SEO pages).
  return (
    <SendMoneyCalculatorPage
      key={pair.slug}
      heroTitle={pair.heroTitle}
      initialTarget={pair.target}
    />
  );
}
